/**
 * Typed access to build-time environment configuration.
 * All environment variables are read here and nowhere else.
 */

export type AppEnvironment = "development" | "qa" | "uat" | "production";

interface AppConfig {
  /** Deployment environment name. */
  environment: AppEnvironment;
  /** Base URL of the backend API gateway. */
  apiBaseUrl: string;
  /** Application version injected at build time. */
  version: string;
}

function readEnvironment(): AppEnvironment {
  const value = import.meta.env.VITE_APP_ENV as string | undefined;
  switch (value) {
    case "qa":
    case "uat":
    case "production":
      return value;
    default:
      return "development";
  }
}

export const appConfig: AppConfig = {
  environment: readEnvironment(),
  apiBaseUrl: (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? "/api",
  version: (import.meta.env.VITE_APP_VERSION as string | undefined) ?? "0.0.0-local",
};

export const isProduction = appConfig.environment === "production";
